
import React from "react";

import MasterLogo from './MasterLogo';

export default function MasterAvatar({
  size = 32,
}: {
  size: number,
}) {
  return (
    <MasterLogo size={size} />
  );
}
